import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import SignificantPeoplePage from './SignificantPeoplePage';
import {
  saveSignificantPeopleForm,
  redirectToAddShareholderPage,
  dataCaptureSelectors,
  saveSignatoriesAndShareholdersForm,
  routeToImportantInfoPage
} from '../../store/dataCapture';
import {
  OFFICER_DETAILS,
  SIGNATORIES_SHAREHOLDER_DATA,
  PRIMARY_APPLICANT,
  APPLICANT_FLOW
} from '../../utils/constants';
import {
  officerSelector,
  saveOfficerDetails,
  removeOfficerDetails,
  addOfficer
} from '../../infrastructure/officer';
import { addressSelector } from '../../infrastructure/address';
import { selectors as caseSelectors } from '../../infrastructure/cases';

class SignificantPeople extends Component {
  componentDidMount() {
    const { isSoleTrader, primaryApplicant, addOfficer } = this.props;
    if (isSoleTrader && !primaryApplicant.officer_id) {
      addOfficer(primaryApplicant, '', 'PRIMARY');
    }
  }

  render() {
    const {
      bankId,
      brandId,
      saveSignificantPeopleForm,
      officersDetails,
      removeOfficerDetails,
      isSoleTrader,
      redirectToAddShareholderPage,
      saveOfficerDetails,
      addressHistory,
      userName,
      signatoriesAndShareholder,
      isPrimaryApplicantEditFlow,
      routeToImportantInfoPage,
      primaryApplicant,
      saveSignatoriesAndShareholdersForm,
      linkCode
    } = this.props;

    return (
      <SignificantPeoplePage
        brandId={brandId}
        bankId={bankId}
        saveSignificantPeopleForm={() => {
          if (linkCode && !isPrimaryApplicantEditFlow) {
            routeToImportantInfoPage();
          } else {
            saveSignificantPeopleForm();
          }
        }}
        officersDetails={officersDetails}
        redirectToAddShareholderPage={redirectToAddShareholderPage}
        saveOfficerDetails={saveOfficerDetails}
        removeOfficerDetails={removeOfficerDetails}
        userName={userName}
        isSoleTrader={isSoleTrader}
        primaryApplicant={primaryApplicant}
        addressHistory={addressHistory}
        linkCode={linkCode}
        saveSignatoriesAndShareholdersForm={saveSignatoriesAndShareholdersForm}
        signatoriesAndShareholder={signatoriesAndShareholder}
      />
    );
  }
}

SignificantPeople.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveSignificantPeopleForm: PropTypes.func.isRequired,
  savePersonDetails: PropTypes.func.isRequired,
  officersDetails: PropTypes.array
};

const actionCreators = {
  saveSignificantPeopleForm,
  redirectToAddShareholderPage,
  saveOfficerDetails,
  removeOfficerDetails,
  addOfficer,
  saveSignatoriesAndShareholdersForm,
  routeToImportantInfoPage
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  officersDetails: officerSelector.getBusinessData(state, OFFICER_DETAILS),
  signatoriesAndShareholder: dataCaptureSelectors.getBusinessData(
    state,
    SIGNATORIES_SHAREHOLDER_DATA
  ),
  addressHistory: addressSelector.noOfAddresses(state),
  userName: caseSelectors.getName(state),
  isSoleTrader: caseSelectors.isSoleTrader(state),
  primaryApplicant: officerSelector.getBusinessData(state, PRIMARY_APPLICANT),
  isPrimaryApplicantEditFlow: selectors.getSingleEntry(state, APPLICANT_FLOW),
  linkCode: caseSelectors.getJointLinkCode(state)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SignificantPeople);
